<template>
    <v-list>
        <v-list-item
                v-for="item in popPartners"
        >
            <v-list-item-avatar>
                <v-avatar class="m-auto"
                          size="40px"
                          color="accent"
                >
                    <img  v-if="item.partnerLogo!=null" :src="$root.docsUrl+item.partnerLogo">
                    <img v-else src="../../assets/noavatar.png" height="40" width="40"/>
                </v-avatar>
            </v-list-item-avatar>

            <v-list-item-content>
                <v-list-item-title>
                    <v-row>
                        <v-col cols="4">
                            <span class="org-name">{{item.orgName}}</span>
                        </v-col>
                        <v-col >
                            <span class="org-address">{{item.address}}</span>
                        </v-col>
                    </v-row>
                    </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
                <span class="count-activates">{{item.count}}</span>
            </v-list-item-action>
        </v-list-item>
    </v-list>
</template>

<script>
    export default {
        name: "PopPartnersList",
        props:{
            lastDays: {
                type: Number,
                default: 0
            },
            limited:{
                type:Boolean,
                default:false
            }
        },
        mounted(){
            this.getPopPartners()
        },
        computed:{
            popPartners(){
                return this.$store.state.Statistic.popPartners
            },
        },
        methods:{
            getPopPartners(){
                let params={
                    lastDays:this.lastDays,
                    isLimit:this.limited
                }
                this.$store.dispatch("Statistic/loadPopPartners", params).catch(err=>{
                    this.$bvToast.toast(err.message, {
                        title: `Ошибка загрузки партнеров!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                })
            },
        },
        watch:{
            lastDays(value){
                this.getPopPartners()
            }
        }

    }
</script>

<style scoped>
    .org-name{
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 20px;
        color:black;
    }

    .org-address{
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #6E7C8D;
    }

    .count-activates{
        font-weight: 600;
        font-size: 32px;
        line-height: 40px;
        text-align: right;
        color: #000000;
    }
</style>